module.exports = __webpack_public_path__ + "static/media/industry.2741aac4.jpeg";